import React from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';

const ProgressBar = ({ stages, currentStage }) => {
  const completed = stage =>
    stages.indexOf(stage) <= stages.indexOf(currentStage);
  return (
    <div className="progressbar-container">
      <div className="progressbar">
        {stages.map(stage => (
          <ProgressBarStage
            key={stage}
            label={T.translate(stage)}
            completed={completed(stage)}
          />
        ))}
      </div>
    </div>
  );
};

const ProgressBarStage = ({ label, completed }) => {
  const completedClass = completed ? 'progressbar-stage--completed' : ''
  return (
    <div className={`progressbar-stage ${completedClass}`}>
      <label className="caption">{label}</label>
      <div className="progressbar-stage-indicator" />
    </div>
  );
};

ProgressBar.propTypes = {
  stages: PropTypes.array.isRequired,
  currentStage: PropTypes.string.isRequired,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/ProgressBar.js